import { createContext, Dispatch } from "react";
import useSaveSearchReducer, { ISaveSearchInputAction, ISaveSearchModalPayload } from "./useSaveSearchReducer.hook";

export const SaveSearchContext = createContext<{ state: ISaveSearchModalPayload, dispatch: Dispatch<ISaveSearchInputAction> } | null>(null);

export const SaveSearchProvider: React.FunctionComponent = (props) => {
  const [ state, dispatch ] = useSaveSearchReducer();

  return (
    <SaveSearchContext.Provider value={{ state, dispatch }}>
      {props.children}
    </SaveSearchContext.Provider>
  )
}